import es from '@/language/es.json';
import en from '@/language/en.json';

const translator = {
  languages: { es, en },

  getLanguage() {
    return localStorage.getItem('language') || 'es';
  },

  setLanguage(language) {
    localStorage.setItem('language', language);
  },

  capitalizar(str) {
    try {
      str = str.replace('_',' ') || str;
      return str.charAt(0).toUpperCase() + str.slice(1);

    }
    catch {
      return str;
    }
  },

  t(key, params) {
    const language = this.getLanguage();
    let value = this.languages[language][key] || this.capitalizar(key);
    if (params && typeof params === 'object') {
      Object.keys(params).forEach(k => {
        value = value.replace(new RegExp('\\{' + k + '\\}', 'g'), params[k]);
      });
    }
    return value;
  }


};

export default translator;
